import { makeStyles } from "@material-ui/core";

const useStyles = makeStyles({
  img: {
    width: "auto",
    height: "100%",
    display: "block",
  },
});

const LogoFull = () => {
  const classes = useStyles();

  return (
    <img
      className={classes.img}
      src="/devleaps-forge-white.png"
      alt="DevLeaps Forge Logo"
    />
  );
};

export default LogoFull;
